import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

export default function TextCard({ item, index, handleChanged, activeInactiveClicked, handleDelete }) {
  const { CheckActionPermission } = useComponent();
  const { t } = useTranslation('common');
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
  } = reducer;

  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'delete');
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');

  return (
    <div className="d-flex flex-wrap mt-2 align-items-center justify-content-center">
      <div key={index} className="freetext-container mb-2 flex-fill">
        <div className="input-container">
          <div className="input-group form-floating-label fixed-label">
            <input
              key={index}
              name="freeLabel"
              autoFocus={!item?._id}
              value={item?.keyName ? item?.keyName : ''}
              placeholder={t('TEXT_CARD.FREE_TEXT_TITLE')}
              type="text"
              maxLength="50"
              onChange={(e) => handleChanged(e, index)}
              className="form-control"
              disabled={!MasterAddEditAccess}
            />
            <label className="asterisk-req">
              {t('TEXT_CARD.FREE_TEXT_LABEL')}
              <span>*</span>
            </label>
          </div>
          {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && <label className="text-danger m-0 p-1">{t('TEXT_CARD.TEXT_REQUIRED')}</label>}
          {item?.keyName?.length >= 50 && <label className="text-danger m-0 p-1">{t('CUSTOM_BOM_ATTRIBUTE.MAX_30_CHAR_ALLOWED')}</label>}
        </div>
        <div className="input-action d-flex">
          {item?._id !== '' && MasterAddEditAccess && (
            <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_MODULE.ACTIVE_INACTIVE')}>
              <button
                type="button"
                aria-label="active/inactive"
                className="btn btn-outline mr-0"
                onClick={() => activeInactiveClicked(item?._id)}
                id={item?._id}
              >
                <span className={item.isActive ? 'icon-Eye-Open' : 'icon-Eye-Closed'} />
              </button>
            </CustomTooltip>
          )}
          {MasterDeleteAccess && (
            <CustomTooltip placement="bottom" tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
              <button
                className="btn btn-outline mr-0"
                type="button"
                aria-label="Delete"
                onClick={() => {
                  handleDelete(item?._id ? item?._id : index);
                }}
              >
                <span className="icon-Delete f-24" />
              </button>
            </CustomTooltip>
          )}
        </div>
      </div>
    </div>
  );
}
